import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as projectReducer from "containers/Project/reducer";

import Forecast from "components/UnifiedProject/Forecast/Forecast";

class ForecastContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { deploy: false };
  }

  render() {
    const {} = this.props;

    return <Forecast {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateRunPlotType: (type) => dispatch(runReducer.updateRunPlotType(ownProps.id, type)),
  updateForecastTime: (time) => dispatch(setupReducer.updateForecastTime(ownProps.id, time)),
  updateForecastTimeUnit: (unit) => dispatch(setupReducer.updateForecastTimeUnit(ownProps.id, unit)),
  updateUseForecastLocalRatio: (val) => dispatch(setupReducer.updateUseForecastLocalRatio(ownProps.id, val)),
  updateForecastLocalRatio: (val) => dispatch(setupReducer.updateForecastLocalRatio(ownProps.id, val)),
  fetchForecast: () => dispatch(runReducer.fetchForecast(ownProps.id)),
  updateForecastModelSelection: (modelId) => dispatch(runReducer.updateAndFetchForecastModel(ownProps.id, modelId)),
  downloadForecast: () => dispatch(runReducer.downloadForecast(ownProps.id))
});

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;
  const selModel = runReducer.getSelModel(state, ownProps.id);

  let optimized = ownProps.optimized;
  if (!optimized || Number(optimized.projectId) !== Number(ownProps.projectId)) {
    optimized = projectReducer.getOptimized(state, ownProps.projectId);
  }

  return {
    isForecast: setupReducer.getIsForecast(state, ownProps.id),

    isForecastLoading: runReducer.getIsForecastLoading(state, ownProps.id),
    isTraining: projectReducer.getIsTraining(state, ownProps.projectId),

    models: models,
    model: selModel,
    bestModel: bestModel,

    setupLabels: setupReducer.getSetupLabels(state, ownProps.id),

    isError: runReducer.getIsError(state, ownProps.id),
    errorMessages: runReducer.getErrors(state, ownProps.id),

    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),
    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",

    setupChanged: setupReducer.getSetupChanged(state, ownProps.id),

    isEditBlueprint: blueprintReducer.getIsEditing(state, ownProps.blueprintId),

    optimized: optimized,
    isOverallSegment: projectReducer.getIsOverallSegment(state, ownProps.projectId, ownProps.id),

    currentRatio: setupReducer.getCurrentRatio(state, ownProps.id),
    forecastTime: setupReducer.getForecastTime(state, ownProps.id),
    forecastTimeUnit: setupReducer.getForecastTimeUnit(state, ownProps.id),
    forecastTimeOptions: setupReducer.getForecastTimeOptions(state, ownProps.id),
    forecastTimeCol: setupReducer.getForecastTimeCol(state, ownProps.runId),
    forecastResults: runReducer.getForecastResults(state, ownProps.id),
    forecastPredictionPlot: runReducer.getForecastPredictionPlot(state, ownProps.id),
    useForecastLocalRatio: setupReducer.getUseForecastLocalRatio(state, ownProps.id),
    forecastLocalRatio: setupReducer.getForecastLocalRatio(state, ownProps.id),
    forecastModelSelection: runReducer.getForecastModelId(state, ownProps.id),
    forecastModelOptions: runReducer.getForecastModelOptions(state, ownProps.id),
    forecastQuantile: runReducer.getForecastQuantile(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ForecastContainer);
